import * as React from 'react';

export interface IPrefetchContentProps {
    url: string;
}
 
const PrefetchContent: React.SFC<IPrefetchContentProps> = ({url}) => {
    return ( <link rel="prefetch" href={url} /> );
}
 
export default PrefetchContent;


// WEBPACK FOOTER //
// ./src/components/shared/footer/PrefetchContent.tsx